









import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State, Action, namespace, Mutation } from 'vuex-class'
import WrapYKDHeader from '@/apps/sandwich/parts/widgets/header.vue'

const ModuleUser = namespace('app-sandwich/user')

@Component({
  components: {
    WrapYKDHeader
  }
})
export default class App extends Vue {
  @ModuleUser.State(state => state.isLogin) private isLogin!: boolean
  mounted() {
    if (window.parent) {
      window.parent.postMessage('finished', '*')
    }
  }
  private onSearch(url: string) {
    this.$router.push(url)
  }
}
